import React, { useEffect, useState, useCallback, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useRealtimeTags } from 'Core/hooks';
import { InputSearch, Select, Button } from 'Components'
import { Grid, Typography, LinearProgress } from '@mui/material';
import { Checkbox } from 'Components/uiControls';
import { injectIntl } from 'react-intl'
import { endpoints } from 'Core/defaultValues'
import { findColor, getIconGroupWithAnotherColor, radiusFeetToMeters, getTagsIdsArray } from 'Components/Map/utils';
import { MenuComponent } from 'Components/Menu'
import useExport from 'Components/Table/Export'
import { ExportButton } from 'Components/TableView/Toolbar'
import { cutNotes, OrderData } from 'Core/data/Helpers'
import _ from 'lodash'
import { TypeLayer } from 'Components/Map/providers/enums'
import InfiniteScroll from "react-infinite-scroll-component"
import { TagsGroup } from 'Components/Tag'
import styles from 'Assets/sass/core/vars.scss';
import { NotificationManager } from 'Components/Notifications';

import './style.scss'

//Views
import CreateEdit from '../landmarkCreateEdit';
import Delete from '../landmarkDelete';
import LandmarkBulk from '../landmarkBulk';
import LandmarkImport from '../landmarkImport'

/*********************************************************
* Globals
*********************************************************/
const pathFile = `https://s3.amazonaws.com/${endpoints.PUBLIC_REPOSITORY_CODE}`
const LIMIT_PAGE = 10;

const parseUserTagIds = (value) => {
    let list = [];
    if (Array.isArray(value)) list = value;
    else {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) list = parsed;
        } catch (e) {}
    }
    return list.map(Number).filter((id) => !Number.isNaN(id));
};

/*********************************************************
 * Actions
*********************************************************/
import {
    mapLandmarksOpenEditCreateModal,
    mapLandmarksOpenDeleteModal,
    mapLandmarkBulkOpenModal,
    mapLandmarkImportModal,
    searchLandmarks,
    clearLandmarks
} from 'Redux/actions';

const LandmarkSettingsView = (props) => {
    const { intl, mapRef } = props;
    const { messages } = intl;

    //list of menus
    const landmarkActions = [
        messages['map_landmark_edit'],
        messages['map_landmark_delete']
    ];

    /*********************************************************
     * States
    *********************************************************/

    const dispatch = useDispatch();

    const [filter, setFilter] = useState('');
    const [group, setGroup] = useState();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [checkSelectAll, setCheckSelectAll] = useState(false); //Default unselected all
    const [selectedRow, setSelectedRow] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [unselectedRows, setUnselectedRows] = useState([]);
    const [exporType, setExportType] = useState('')
    const [exportData, setExportData] = useState([])

    /*********************************************************
     * Use selector
    *********************************************************/
    //const { loadingLandmarkGroups, landmarkGroupsPreferences } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);
    //const { landmarkTags, landmarkTagsLoading } = useSelector((state) => state.realtimeMapLandmarkListModuleRedux);
    const landmarkTagsAssigned = useSelector((state) => state.realtimeMapLandmarkListModuleRedux.landmarkTags);
    const landmarkTagsLoading = useSelector((state) => state.realtimeMapLandmarkListModuleRedux.landmalandmarkTagsLoadingrkTags);

    const jsonLandmark = useSelector((state) => state.catalogsRealtimeRedux.landmarks);
    const loadingLandmarkJson = useSelector((state) => state.catalogsRealtimeRedux.loadingLandmarks);

    const { open: openLandmarkBulk } = useSelector((state) => state.realtimeMapLandmarkBulkModuleRedux);
    const { open: openLandmarkCreateEdit, openImport } = useSelector((state) => state.realtimeMapLandmarkCreateEditModuleRedux);

    const tags  = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags', 'color', 'parentId'] });
    const isSubUser = useSelector((state) => state.securityRedux?.user?.isSubUser);
    const tagIds = parseUserTagIds(useSelector((state) => state.securityRedux?.user?.tagIds));
    const shouldRestrict = !!isSubUser && !tagIds.includes(-99);

    const permittedLandmarks = !shouldRestrict ? jsonLandmark : (jsonLandmark || []).filter((item) => {
        const ids = getTagsIdsArray(item.tagsId);
        if (!ids.length || ids.every((id) => id === '-1')) return tagIds.includes(-1);
        return ids.some((id) => tagIds.includes(Number(id)));
    });

    const landmarkHasNoTag = (landmark) => {
        const tagsIds = getTagsIdsArray(landmark.tagsId);
        return tagsIds.includes('-1') || tagsIds.length === 0;
    };
    const haveUntagged = shouldRestrict
        ? !!(Array.isArray(permittedLandmarks) && permittedLandmarks.some(landmarkHasNoTag))
        : !!(
            (jsonLandmark && Array.isArray(jsonLandmark) && jsonLandmark.some(landmarkHasNoTag)) ||
            (tags && Array.isArray(tags) && tags.some(tag => tag.id === -1)) ||
            (!tags || tags.length === 0)
        );

    const landmarkTags = landmarkTagsAssigned && landmarkTagsAssigned?.length > 0 ? landmarkTagsAssigned : tags
    const {
        landmarks,
        loading
    } = useSelector((state) => state.entitySelectorRedux);

    /*********************************************************
     * Set the groups preferences
    *********************************************************/
    useEffect(() => {
        if (group && jsonLandmark && jsonLandmark.length > 0) {
            restartView();
        } else {
            getAllLandmarks();
        }
    }, [landmarkTags])

    useEffect(() => {
        dispatch(mapLandmarkImportModal(false));
    }, [])
    /*********************************************************
     * Set the landmarks by rows per page in start data
    *********************************************************/
    useEffect(() => {
        if (group && jsonLandmark && jsonLandmark.length > 0) {
            restartView();
        } else {
            getAllLandmarks()
        }
    }, [group, jsonLandmark, shouldRestrict])

    useEffect(() => {
        if(landmarks?.length && !loading) setExportData(landmarks)
    }, [landmarks, loading])

    useEffect(() => {
        if(exportData?.length && !loading){
            const exportCSVPdf = useExport(
                getHeaders,
                getDataToExport,
                [],
                exportData.length ? exportData : [],
                null,
                messages['map_landmark_manage_export'],
                null,
                true
            );

            if (exporType === 'CSV') {
                NotificationManager.success(
                    messages['exportSuccess'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success'
                );
               dispatch(clearLandmarks());     
               return exportCSVPdf.exportCSV();
            } else if (exporType === 'PDF') {
                NotificationManager.success(
                    messages['exportSuccess'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success'
                );
                dispatch(clearLandmarks());     
                setExportData([])
               return  exportCSVPdf.exportPDF();
            }
        }
    }, [exportData])

    /*********************************************************
     * Start to get all landmarks into the view
    *********************************************************/
    const getAllLandmarks = () => {
        let newLandmarks = [];
        if (landmarkTags && landmarkTags.length > 0 && !group) {
            if (haveUntagged) {
                newLandmarks = OrderData(permittedLandmarks, 'name');
            } else {
                //only groups to enable this user
                landmarkTags.forEach((tag) => {
                    newLandmarks = [
                        ...newLandmarks,
                        ...permittedLandmarks.filter((item) => {
                            if (item.tagsId) {
                                const tagsIds = item.tagsId.split(',')
                                return tagsIds.includes(tag.id.toString())
                            }
                            return false;
                        })
                    ];
                })
                newLandmarks = OrderData(newLandmarks, 'name');
            }
            const toSetLandmarks = [...newLandmarks]
            setData(toSetLandmarks.slice(0, page * LIMIT_PAGE));
        }else if(haveUntagged){
            newLandmarks = OrderData(permittedLandmarks, 'name');
            const toSetLandmarks = [...newLandmarks]
            setData(toSetLandmarks.slice(0, page * LIMIT_PAGE));
        }
        return newLandmarks;
    }

    /*********************************************************
     * Restart the elements into the view
    *********************************************************/
    const restartView = () => {
        setSelectedRows([]);
        setSelectedRow(null);
        setPage(1); //start page count
        getItemsLandmark(1);
        setCheckSelectAll(false);
        setUnselectedRows([])
    }

    /*********************************************************
     * Draw the landmarks into the map
    *********************************************************/
    const getAllFilteredLandmarks = () => {
        let filteredLandmarks = []
        if (group && group.length > 0 && permittedLandmarks && permittedLandmarks.length > 0) {
            group.forEach((tag) => {
                const matches = permittedLandmarks.filter((item) => {
                    if (item.tagsId && item?.tagsId != "-1") {
                        const tagsIds = item.tagsId.split(',')
                        return tagsIds.includes(tag.id.toString())
                    } else if (haveUntagged && tag.id == 0) {
                        return (item.tagsIds == null)
                    }
                    return false;
                });
                filteredLandmarks = [
                    ...filteredLandmarks,
                    ...matches
                ];
            })
        } else {
            if (haveUntagged) {
                filteredLandmarks = [...permittedLandmarks];
            } else {
                filteredLandmarks = [...getAllLandmarks()]
            }
        }
        const result = OrderData(filteredLandmarks, 'name');
        return result;
    }

    const getItemsLandmark = (newPage = 0) => {
        let filteredLandmarks = []
        if (group && group.length > 0 && permittedLandmarks && permittedLandmarks.length > 0) {
            group.forEach((tag) => {
                //tag.id
                const matches = permittedLandmarks.filter((item) => {
                    if (item.tagsId && item?.tagsId != "-1") {
                        const tagsIds = item.tagsId.split(',')
                        return tagsIds.includes(tag.id.toString())
                    } else if (haveUntagged && tag.id == 0) {
                        return (item.tagsIds == null)
                    }
                    return false;
                });
                filteredLandmarks = [
                    ...filteredLandmarks,
                    ...matches
                ];
            })
        } else {
            if (haveUntagged) {
                filteredLandmarks = [...filteredLandmarks, ...permittedLandmarks];
            } else {
                //filter the tags by user permissions
                filteredLandmarks = [...getAllLandmarks()]
            }
        }
        let newLandmarks = OrderData(filteredLandmarks, 'name');
        setData(newLandmarks.slice(0, (newPage > 0 ? newPage : page) * LIMIT_PAGE));

        if (checkSelectAll) {
            setSelectedRows(filteredLandmarks);
        }
    }

    /*********************************************************
     * set the new page from event infinite scroll
    *********************************************************/
    const setNoPage = (page) => {
        setPage(page);
        getItemsLandmark(page);
    }

    /*********************************************************
     * get information from text component in view. filter the elements
    *********************************************************/
    const onSearch = useCallback((value) => {
        setFilter(value);

        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }

        if (!value) {
            setPage(1); //start page count
            getItemsLandmark(1);
            setCheckSelectAll(false);
            return;
        }

        if (checkSelectAll) {
            setCheckSelectAll(false);
            setSelectedRows([]);
        }

        if (group) {
            setGroup()
        }

        window.typingTime = setTimeout(() => {
            if (!value) return;
            let idsForGroups = []
            if (landmarkTags && landmarkTags.length > 0) {
                idsForGroups = landmarkTags.map((item) => parseInt(item.id))
            }

            const newFilter = permittedLandmarks.filter((item) =>
                value &&
                validateIncludes(item, idsForGroups) &&
                (item.name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
                    item.address.toLocaleLowerCase().includes(value.toLocaleLowerCase())))

            setData(newFilter.slice(0, LIMIT_PAGE * 2));
            window.typingTime = null;
        }, 1000);
    });

    /*********************************************************
     * Validate include ids in array
    *********************************************************/
    const validateIncludes = (landmark, idsForGroups) => {
        let valueReturn = false
        if (landmark.tagsId && landmark?.tagsId != "-1") {
            const tagsIds = landmark.tagsId.split(',')
            idsForGroups.forEach((tagId) => {
                if (tagsIds.includes(tagId.toString())) {
                    valueReturn = true;
                }
            })
        } else if (haveUntagged) {
            //Untagged landmark
            valueReturn = true
        }

        return valueReturn
    }

    /*********************************************************
     * Selected all items in grid view
    *********************************************************/
    const selectAllRows = (checked, data) => {
        if (checked) {
            const filter = data
            setSelectedRows(filter);
        } else {
            setSelectedRows([]);
        }
        setCheckSelectAll(checked);
    }

    /*********************************************************
     * Check new element into the list
    *********************************************************/
    const selectRow = (row, value) => {
        let newSelectedRows = [];
        if (value) {
            newSelectedRows = [...selectedRows];
            newSelectedRows.push(row);
        } else {
            newSelectedRows = selectedRows.filter(selectedRow => selectedRow.id !== row.id);
        }

        setSelectedRows([...newSelectedRows]);

        if(checkSelectAll){
            let unselectedData = [...unselectedRows]
            if(value){ //if true remove from the list
                unselectedData = unselectedData.filter(unselected => unselected.id !== row.id);
            }else{
                //add the item into the list
                unselectedData.push(row)
            }
            setUnselectedRows(unselectedData)
        }

    }

    /*********************************************************
     * Return teh landmarks groups by groupID
    *********************************************************/
    const getLandmarkGroupById = useCallback((landmark) => {
        return landmarkTags.find((item) => item.id == landmark.tagId)
    })

    /*********************************************************
     * Get the icon url from landmarks or landmark group
    *********************************************************/
    const getIconLandmark = useCallback((landmark) => {
        const landmarkGroup = landmarkTags.find((item) => getTagsIdsArray(landmark.tagsId).includes(item.id.toString()))
        let landmarkColor = landmark.color ? landmark.color : landmarkGroup?.color || ''
        let landmarkIcon = landmarkGroup && landmarkGroup.iconName ? landmarkGroup.iconName : '' //get icon from landmark group
        landmarkIcon = landmark.iconName ? landmark.iconName : getIconGroupWithAnotherColor(landmarkIcon, landmark.color)// get icon from landmark

        if (!landmarkIcon) {
            landmarkColor = findColor(landmarkColor.replace("#", ""));
            landmarkIcon = `${pathFile}/kmls/flagicon/${landmarkColor}.png`
        } else {
            landmarkIcon = `${pathFile}/${landmarkIcon}`
        }

        return { color: landmarkColor, icon: landmarkIcon }
    })

    /*********************************************************
     * Select the card into the table
    *********************************************************/
    const onSelectCard = (row) => {
        if (row?.id == selectedRow?.id) {
            setSelectedRow(null);
        } else {
            setSelectedRow(row);
            findLandmarkOnMap(row);
        }
    }

    /*********************************************************
     * Draw the landmarks into the map
    *********************************************************/
    const findLandmarkOnMap = (item) => {
        const isInfoBubbleOpened = props?.mapRef?.current?.getOpenInfoWindow();
        if (!_.isEqual(selectedRow, item) || !isInfoBubbleOpened) {
            const coordinates = new google.maps.LatLng(item.latitude, item.longitude); // eslint-disable-line no-undef
            const radius = item.shape == "circle" ? item.radius : 0
            const coordinatesCenter = radius > 0 ? [{ lat: item.latitude, lng: item.longitude }] : item.coordinates
            props.mapRef.current.centerByFitBounds(coordinatesCenter, radius)
            const mapObject = {
                id: item?.id,
                position: coordinates,
                label: item?.name,
                icon: {
                    rotation: 0
                },
                layerName: TypeLayer.Landmark
            }
            props.mapRef.current.modalPopupEvent(mapObject, mapObject);

            //Always show the landmark on map
            props.mapRef.current.removeLayer(TypeLayer.TemporalObjects);
            props.mapRef.current.drawLandmark({ ...item, hideMarker: true }, radiusFeetToMeters(radius), coordinatesCenter, true)
        }
    }

    /********************************************************
     * Define the columns to export data
     ********************************************************/
    const getHeaders = () => {
        return [
            messages["realtimemaps_landmarks_grid_title"],
            messages["realtimemaps_landmarks_grid_address"],
            messages["realtimemaps_landmarks_grid_latlng"],
            messages["realtimemaps_landmarks_grid_radius"],
            messages["realtimemaps_landmarks_grid_groups"],
            messages["realtimemaps_landmarks_grid_notes"]];
    }

    /********************************************************
     * Get data to generate files PDF or CSV
     ********************************************************/
    const getDataToExport = (rows) => {
        let items = rows ? rows : [];
        let data = [];

        //Filter export by selection
        if (selectedRows && selectedRows.length > 0) {
            const onlyIds = selectedRows.map(item => item.id)
            items = items.map((element) => {
                if (onlyIds.includes(element.id))
                    return element
                return null
            })
            items = items.filter(item => item)
        }

        items.forEach((item) => {
            const title = item.name
            const address = item.address ? item.address : "";
            const latlng = `${item?.latitude.toFixed(6)} / ${item?.longitude.toFixed(6)}`
            const radius = item.radius ? item.radius : "";
            const tagsName = item?.tags?.map(temTag => temTag?.label)?.join(", ")
            const notes = item?.note

            data.push([title, address, latlng, radius, tagsName, notes]);
        });

        return data;
    }

    /********************************************************
     * Get the tag name value
     ********************************************************/
    const getTagName = (tagsId) => {
        let stringNameTags = '';
        if (tagsId) {
            const tagsIds = tagsId.split(',')
            landmarkTags.forEach((tagId) => {
                if (tagsIds.includes(tagId.id.toString()))
                    stringNameTags = stringNameTags + tagId.name + ', ';
            })
            stringNameTags = stringNameTags.slice(0, -2)
        }

        return stringNameTags;
    }

    /*********************************************************
     * Options to export data (Button)
    *********************************************************/
    const onExport = (item) => {
        setExportType(item)
        NotificationManager.info(
            messages['exportInProcessBody'],
            messages['exportInProcessTitle'],
            4000,
            null,
            null,
            'info',
            null
        );
        if(group?.length){
            const joinGroups = group?.map(item => item?.id)
            dispatch(searchLandmarks(10000, 0, filter, false, joinGroups))
        }else{
            dispatch(searchLandmarks(10000, 0, filter, false))
        }
    }

    /*********************************************************
     * Convert tags to array
    *********************************************************/
    const convertTagStringToArray = (landmark) => {
        if (landmark.tagsId) {
            const tagsIds = landmark.tagsId.split(',')
            let tagsListFinal = []
            tagsIds.forEach((tagId) => {
                const newTagElement = landmarkTags.find((element) => element.id == parseInt(tagId))
                if (newTagElement) {
                    tagsListFinal.push({ ...newTagElement, color: newTagElement?.color || "#000000" });
                }

            });

            return tagsListFinal
        }

        return []
    }

    /*********************************************************
     * Add the list with untagged groups
    *********************************************************/
    const getTags = () => {
        if (haveUntagged) {
            let tagItems = [];
            tagItems = [...tagItems, ...(landmarkTags || [])];
            tagItems = tagItems ? OrderData(tagItems, "name") : [];
            tagItems.unshift({
                id: 0,
                name: messages['untagged'],
                color: styles.color_untagged,
                visible: true,
                open: false,
                items: []
            })

            return tagItems;
        }

        return landmarkTags ? OrderData(landmarkTags, "name") : [];
    }

    return (
        <div>
            <Grid container spacing={0}>
                <Grid item sm={12}>
                    <InputSearch
                        searchText={filter}
                        onSearch={(param) => onSearch(param)}
                    />
                </Grid>

                <Grid item sm={12} style={{ marginBottom: 8 }}>
                    <Select
                        value={group}
                        onChange={(event) => {
                            setGroup(event);
                            setSelectedRow(null);
                            setSelectedRows([]);
                        }}
                        id="id"
                        className="react-select-landmark"
                        placeholder={messages['maputilities_visible_filterByTags']}
                        options={getTags()}
                        textField={'name'}
                        valueField={'id'}
                        required
                        disabled={landmarkTagsLoading || filter}
                        multiple
                        closeMenuOnSelect={true}
                    />
                </Grid>
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <Grid item
                    style={{
                        paddingTop: 1
                    }}
                >
                    <Checkbox
                        id={'-selectAll'}
                        value={checkSelectAll}
                        partiallySelected={selectedRows.length > 0 && selectedRows.length < data?.length}
                        size="md"
                        onChange={(checked) => {
                            selectAllRows(checked, data);
                        }}
                    />
                </Grid>

                <Grid item>
                    <Button
                        type="icon"
                        icon="add_box"
                        tooltip={messages['add']}
                        size="medium"
                        fontSize="inherit"
                        onClick={() => {
                            dispatch(mapLandmarksOpenEditCreateModal(true));
                            setFilter('');
                        }}
                    />
                </Grid>

                <Grid item>
                    <Button
                        type="icon"
                        icon="file_upload"
                        size="medium"
                        fontSize="inherit"
                        tooltip={messages['map_landmark_import']}
                        onClick={() => {
                            dispatch(mapLandmarkImportModal(true));
                        }}
                    />
                </Grid>
                {
                    selectedRows?.length === 0 &&
                        <Grid item>
                            <ExportButton
                                onExport={onExport}
                                className='landmark-icon-download'
                                size="medium"
                                fontSize="inherit"
                            />
                        </Grid>
                }

                <Grid item>
                    {
                        selectedRows.length > 0 &&
                        <Button
                            type="icon"
                            icon="delete"
                            tooltip={messages['delete']}
                            size="medium"
                            fontSize="inherit"
                            disabled={!selectedRows.length}
                            onClick={() => {
                                const hasGroupFilter = checkSelectAll && group && group.length > 0;
                                let landmarksToDelete = selectedRows;
                                let isDeleteAll = checkSelectAll && !hasGroupFilter;
                                let filterTagsToPass = null;

                                if (hasGroupFilter) {
                                    const allFiltered = getAllFilteredLandmarks();
                                    landmarksToDelete = allFiltered.filter(
                                        (l) => !unselectedRows.find((u) => u.id === l.id)
                                    );
                                    filterTagsToPass = group;
                                }

                                dispatch(mapLandmarksOpenDeleteModal(true, landmarksToDelete, isDeleteAll, unselectedRows, filterTagsToPass));
                                setSelectedRows([]);
                                selectAllRows(false);
                                setUnselectedRows([]);
                                setFilter('');
                            }}
                        />
                    }
                </Grid>

                <Grid item>
                    {
                        selectedRows.length > 0 &&
                        <Button
                            type="icon"
                            icon="settings"
                            size="medium"
                            fontSize="inherit"
                            disabled={!selectedRows.length}
                            tooltip={messages['map_landmark_bulk_actions']}
                            onClick={() => {
                                dispatch(mapLandmarkBulkOpenModal(true, selectedRows));
                                setSelectedRows([]);
                                setFilter('');
                            }}
                        />
                    }
                </Grid>
            </Grid>


            {loadingLandmarkJson && <LinearProgress />}
            <InfiniteScroll
                dataLength={data.length}
                height={'53vh'}
                next={() => {
                    if (!filter) { //when the user not filter de data
                        setNoPage(page + 1);
                    }
                }}
                hasMore={(permittedLandmarks.length > data.length)}
                loader={<span />}
                endMessage={""}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    {
                        data.map((row, index) => {
                            let selected = selectedRows.find(selectedRow => selectedRow.id === row.id);

                            return (
                                <Grid
                                    key={index}
                                    item
                                    xs
                                    style={{
                                        width: '100%',
                                        margin: 0
                                    }}
                                >
                                    <div style={{ padding: '10px 15px 10px 1px' }}>
                                        <div
                                            className={row?.id === selectedRow?.id ? "lSettingsView-card lSettingsView-container-selected" : "lSettingsView-card lSettingsView-container"}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                            >
                                                <Grid item>
                                                    <Checkbox
                                                        id={'checked_' + row?.id}
                                                        value={selected ? true : false}
                                                        size="sm"
                                                        onChange={(checked) => {
                                                            selectRow(row, checked);
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item>
                                                    <img style={{ width: 20, height: 20 }} src={getIconLandmark(row).icon} className="lSetting-start-icon" />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs
                                                    zeroMinWidth
                                                    style={{
                                                        paddingRight: 20
                                                    }}
                                                >
                                                    <Typography
                                                        noWrap
                                                        variant="subtitle1"
                                                        className="lSetting-title"
                                                        onClick={() => onSelectCard(row)} //implement select card
                                                    >
                                                        {row?.name}
                                                    </Typography >
                                                </Grid>

                                                <Grid item style={{ position: 'relative' }}>
                                                    <MenuComponent
                                                        disabled={loadingLandmarkJson || landmarkTagsLoading}
                                                        options={landmarkActions}
                                                        icon={'more_vert'}
                                                        className="lSetting-actions icon-menu-vehicle-service showInHover"
                                                        onClick={(type) => {
                                                            if (type === messages['map_landmark_edit']) {
                                                                findLandmarkOnMap(row);
                                                                dispatch(mapLandmarksOpenEditCreateModal(true, row.id));
                                                            } else if (type === messages['map_landmark_delete']) {
                                                                dispatch(mapLandmarksOpenDeleteModal(true, [row]));
                                                            }
                                                            setFilter('');
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                wrap="nowrap"
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                onClick={() => onSelectCard(row)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Grid item xs zeroMinWidth>
                                                    <Typography
                                                        className="lSetting-detail"
                                                        noWrap
                                                        variant="subtitle2"
                                                        color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}
                                                    >
                                                        {row?.address}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                wrap="nowrap"
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                onClick={() => onSelectCard(row)}
                                                style={{ cursor: 'pointer', marginTop: 8 }}
                                            >
                                                <Grid item xs={4}>
                                                    <Typography noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                        {messages['map_landmarksettings_landmarks_tags']}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <TagsGroup
                                                        options={convertTagStringToArray(row)}
                                                        nameField="name"
                                                        colorField="color"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                wrap="nowrap"
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                onClick={() => onSelectCard(row)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Grid item xs={4}>
                                                    <Typography noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                        {`${messages['map_landmarksettings_landmarks_note']}:`}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography className="lSetting-detail" noWrap variant="subtitle2" color={row?.id == selectedRow?.id ? 'inherit' : 'textSecondary'}>
                                                        {row?.note || messages['map_landmarksettings_landmarks_none']}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </InfiniteScroll>

            {
                openLandmarkCreateEdit
                &&
                <CreateEdit mapRef={mapRef} />
            }

            {
                //Create the object when user open the modal
                openLandmarkBulk
                &&
                <LandmarkBulk mapRef={mapRef} />
            }
            {
                openImport && <LandmarkImport />
            }
            <Delete />
        </div>
    )
}

export default injectIntl(LandmarkSettingsView);